// extracted by mini-css-extract-plugin
module.exports = {"root":"EmptyPlaylistPlaceholder_root__1ZptC","illustration":"EmptyPlaylistPlaceholder_illustration__30ANe","button":"EmptyPlaylistPlaceholder_button__3qA4-"};